import { useTranslation } from "@redotech/redo-i18n";
import { TotalSpentGreaterThanState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const TotalSpentGreaterThanDetails = memo(
  function TotalSpentGreaterThanDetails({
    state,
    setState,
    disabled,
  }: ConditionTypeDetailsProps<TotalSpentGreaterThanState>) {
    const { t } = useTranslation();
    return (
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Minimum order total")}
        </Text>
        <RedoTextInput
          IconLeading={() => <>$</>}
          inputTypeHint="number"
          min={0}
          placeholder="0.00"
          setValue={setState}
          state={disabled ? "readonly" : "default"}
          value={state}
        />
      </Flex>
    );
  },
);
